import { ofType } from 'redux-observable'
import { from } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { searchActresses } from './api'
import { ActressesActions } from './actions'
import { ActressEntity } from './types'
import { CardsActions } from '../cards/actions'
import Converter from '../cards/converter'

export const SearchActressesEpic = (actions$: any) => (
  actions$.pipe(
    ofType(ActressesActions.searchActresses.started),
    switchMap((action: any) => {
      return from(searchActresses(action.payload))
        .pipe(
          switchMap((actresses: ActressEntity[]) => {
            const cards = actresses.map(actress => new Converter(actress).convert())
            return [
              CardsActions.setCards(cards), ActressesActions.searchActresses.done({params: action.payload})
            ]
          })
        )
    })
  )
)


export default [
  SearchActressesEpic
]
